/**
 * Vuely Global Components
 */
// section tooltip
import UploadFile from './components/UploadFile.vue'
import DisplayImage from './components/DisplayImage.vue'
import PrintWindow from './components/PrintWindow.vue'

import SearchField from './components/SearchField/Index.vue'
import GridPagination from './components/GridPagination.vue'

import BarChart from './components/Graphs/Bar.vue'
import PieChart from './components/Graphs/Pie.vue'
import BubbleChart from './components/Graphs/Bubble.vue'
import LineChart from './components/Graphs/Line.vue'

import Whiteboard from './components/Whiteboard.vue'
import TaskCalendar from './components/TaskCalendar/Index.vue'

const GlobalComponents = {
   install(Vue) {
      Vue.component('UploadFile', UploadFile);
      Vue.component('DisplayImage', DisplayImage);
      Vue.component('PrintWindow', PrintWindow); 

      Vue.component('SearchField', SearchField);   
      Vue.component('GridPagination', GridPagination); 

      Vue.component('BarChart', BarChart);   
      Vue.component('PieChart', PieChart);   
      Vue.component('LineChart', LineChart);   
      Vue.component('BubbleChart', BubbleChart);   

      Vue.component('Whiteboard', Whiteboard);   
      Vue.component('TaskCalendar', TaskCalendar)
   }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/globalComponents.js